import moment from 'moment';
import $i18n from 'panda-i18n';

// 生成uuid
export const getUuid = (index: any) =>
  index + (Math.pow(10, 8) * Math.random()).toString(16).split('.')[0] + Date.now();

export const hasAppointProperty = (obj: any, key) => {
  if (Object.prototype.hasOwnProperty.call(obj, key)) {
    return true;
  }
  return false;
};

/**
 *
 * @param str1
 * @param str2
 * @returns 将两个字段拼接成一个数组
 */
export const transformToStringify = (str1, str2) => {
  const arr = [];
  if ((typeof str1 === 'string' && str1) || (typeof str1 === 'number' && !isNaN(str1))) {
    arr.push(str1);
  }

  if ((typeof str2 === 'string' && str2) || (typeof str2 === 'number' && !isNaN(str2))) {
    arr.push(str2);
  }
  return arr.length > 0 ? JSON.stringify([str1, str2]) : undefined;
};

/**
 *
 * @param str1
 * @returns 将g拼接成一个数组
 */
export const jsonStringify = (arr) => {
  return arr?.length > 0 ? JSON.stringify(arr) : undefined;
};

/**
 *
 * @param str1
 * @returns 将g拼接成一个数组
 */
export const jsonParse = (str) => {
  return isJSONValid(str) ? JSON.parse(str) : str;
};

export const isJSONValid = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 *
 * @param str1
 * @param str2
 * @returns 将数组stringify
 */
export const arrayTransformToStringify = (str1: any[]) => {
  return str1?.length > 0 ? JSON.stringify(str1) : undefined;
};

export const isObject = (obj: any) => Object.prototype.toString.call(obj) === '[object Object]'; // "[object Object]"

// 递归收集所有子节点
const collectAllNodes = (nodes: React.ReactNode, result: React.ReactNode[] = []): React.ReactNode[] => {
  if (!nodes) return result;

  if (Array.isArray(nodes)) {
    nodes.forEach((node) => {
      result.push(node);
      if (isObject(node) && node.props?.children) {
        collectAllNodes(node.props.children, result);
      }
    });
  } else {
    result.push(nodes);
    if (isObject(nodes) && nodes.props?.children) {
      collectAllNodes(nodes.props.children, result);
    }
  }

  return result;
};

const transformToMoment = (timestamps) => {
  if (!timestamps?.length) {
    return [];
  }
  return timestamps.map((timestamp) => (timestamp ? moment(timestamp) : null));
};

const transToTimestamps = (momentArr) => {
  if (!momentArr?.length) {
    return [];
  }
  return momentArr.map((item) => (item ? item.valueOf() : null));
};

const transArrI18n = (dataSource, i18nField, labelField) => {
  if (!dataSource?.length) {
    return [];
  }
  // 格式化
  const newData = dataSource.map((e) => ({
    ...e,
    label: e[i18nField] ? $i18n.get({ id: `${e[i18nField]}`, dm: `${e[labelField]}` }) : e[labelField],
  }));
  return newData;
};

const getCainiaoPackageUrl = (path) => {
  const urlObj: any = {
    '/goods/cainiaoPackage/purchaseOrder': 'https://i.cainiao-inc.com/ceam/inventory/storage/list',
    '/goods/cainiaoPackage/inventoryRequisition': 'https://i.cainiao-inc.com/ceam/inventory/requisition/list',
    '/goods/cainiaoPackage/inventoryRefund': 'https://i.cainiao-inc.com/ceam/inventory/refund/list',
    '/goods/cainiaoPackage/inventoryBalances': 'https://i.cainiao-inc.com/ceam/inventory/report-form/inventory-balance',
    '/goods/cainiaoPackage/inventoryStock': 'https://i.cainiao-inc.com/ceam/inventory/stock-inventory/list',
  };
  const urlObjDev: any = {
    '/goods/cainiaoPackage/purchaseOrder': 'https://pre-h.cainiao-inc.com/ceam/inventory/storage/list',
    '/goods/cainiaoPackage/inventoryRequisition': 'https://pre-h.cainiao-inc.com/ceam/inventory/requisition/list',
    '/goods/cainiaoPackage/inventoryRefund': 'https://pre-h.cainiao-inc.com/ceam/inventory/refund/list',
    '/goods/cainiaoPackage/inventoryBalances':
      'https://pre-h.cainiao-inc.com/ceam/inventory/report-form/inventory-balances',
    '/goods/cainiaoPackage/inventoryStock': 'https://pre-h.cainiao-inc.com/ceam/inventory/stock-inventory/list',
  };
  return document.location.hostname?.includes('test') || document.location.hostname?.includes('localhost')
    ? urlObjDev[path]
    : urlObj[path];
};
export { collectAllNodes, transformToMoment, transToTimestamps, transArrI18n, getCainiaoPackageUrl };

// 处理列表数据中带有的i18n的字段国际化
export const arrayTranslate = (arr: any[]) => {
  if (!arr?.length) {
    return [];
  }
  const dealObj = (item: any) => {
    const keys = Object.keys(item);
    keys.forEach((key) => {
      if (isObject(item[key])) {
        // 如果item[key]是对象，则递归处理
        item[key] = dealObj(item[key]);
      } else if (Array.isArray(item[key])) {
        // 如果item[key]是数组，则递归处理
        item[key] = arrayTranslate(item[key]);
      } else if (key.includes('I18n') && item[key]) {
        const [defaultKey] = key.split('I18n');
        if (key === 'labelI18n') {
          item.label = $i18n.get({ id: `${item[key]}`, dm: item[defaultKey] });
        } else {
          item[`${key}Label`] = $i18n.get({ id: `${item[key]}`, dm: item[defaultKey] });
        }
      }
    });
    return item;
  };
  return arr.map(dealObj);
};
